import { render, staticRenderFns } from "./Archives.vue?vue&type=template&id=6638307c&scoped=true&"
import script from "./Archives.vue?vue&type=script&lang=js&"
export * from "./Archives.vue?vue&type=script&lang=js&"
import style0 from "./Archives.vue?vue&type=style&index=0&id=6638307c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6638307c",
  null
  
)

export default component.exports